import {dataTestId} from '@hconnect/uikit'
import {Alert, AlertProps, useTheme, lighten} from '@mui/material'

type AlertWithLeftBorderProps = AlertProps & {'data-test-id'?: string}

export const AlertWithLeftBorder: React.FC<AlertWithLeftBorderProps> = ({
  children,
  severity,
  'data-test-id': testId,
  ...otherProps
}) => {
  const theme = useTheme()

  const getLeftBorderColor = () => {
    switch (severity) {
      case 'error':
        return theme.palette.error.main
      case 'warning':
        return theme.palette.warning.main
      case 'success':
        return theme.palette.success.main
      default:
        return theme.palette.info.main
    }
  }

  const leftBorderColor = getLeftBorderColor()
  const borderColor = lighten(leftBorderColor, 0.85)

  return (
    <Alert
      severity={severity}
      sx={{
        borderRadius: '4px',
        border: `1.5px solid ${borderColor}`,
        borderLeft: `4px solid ${leftBorderColor}`,
        fontSize: 16,
        lineHeight: '22px'
      }}
      {...otherProps}
      {...dataTestId(testId ?? 'alert-with-left-border')}
    >
      {children}
    </Alert>
  )
}
